import { atom } from 'recoil';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

// export type useInterphon = {
//   sender: string;
//   room_area_name: string;
//   hotel_area_name: string;
// };

export const useInterphoneState = atom<boolean>({
  key: 'useInterphone',
  default: false,
});

export const hotelAreaIdState = atom<number | null>({
  key: 'hotelAreaId',
  default: null,
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem('hotelAreaId');

      if (savedAuthData) setSelf(savedAuthData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem('hotelAreaId')
          : AsyncLocalStorage.setItem('hotelAreaId', JSON.stringify(newValue));
      });
    },
  ],
});
